$(function() {
  // ヘッダーの切り替え
  $(window).on("scroll", function() {
    const mvHeight = $('.mv').height();
    if(mvHeight < $(this).scrollTop()) {
      $('#js-header').addClass('is-fixed');
      $('#js-header-sp').addClass('is-fixed');
      $('.header-sp__cart').addClass('is-fixed');
    } else {
      $('#js-header').removeClass('is-fixed');
      $('#js-header-sp').removeClass('is-fixed');
      $('.header-sp__cart').removeClass('is-fixed');
    }
  });

  // タブの切り替え
  // PCの時
  $('.js-pc-tab').on('click', function() {
    var index = $('.btn-area__item').index(this);
    $('.btn-area__item, .pc-list').removeClass('is-active');
    $(this).addClass('is-active');
    $('.pc-list').eq(index).addClass('is-active');
  });

  // SPの時
  $('.js-sp-tab').on('click', function() {
    var index = $('.js-sp-tab').index(this);
    $('.js-sp-tab, .sp-list').removeClass('is-active');
    $(this).addClass('is-active');
    $('.sp-list').eq(index).addClass('is-active');
  });

  // ランキングのスイラダーの制御
  function sliderSetting() {
    var width = $(window).width();
    if (width <= 1050) {
      $('.ranking-slider').not('.slick-initialized').slick({
        autoplay: true,
        arrows: false,
        infinite: true,
        dots: true,
        // centerMode: true,
        // centerPadding: "10%", 
        // slidesToShow: 1,
        responsive: [{
          breakpoint: 1050,
          settings: {
            slidesToShow: 2,
          }
        },{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }]
      });
    } else {
      $('.ranking-slider.slick-initialized').slick('unslick');
    }
  }
  sliderSetting();
  $(window).resize(function () {
    sliderSetting();
  });

  // infoのスライダーの制御
  $('.info-slide').slick({
    autoplay: true,
    slidesToShow: 2,
    dots: true,
    responsive:[{
      breakpoint:1050,
      settings: {
        slidesToShow: 1,
      }
    },{
      breakpoint:768,
      settings: {
        slidesToShow: 1,
        arrows: false,
      }
    }]
  });
});

// タブスライダーの制御
$(document).ready(function () {
  var slider = $('.tab-slide').slick({
    // autoplay: true,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
  });
  $('.sp-tab').click(function () {
    slider.slick('setPosition');
  });

  $('.concept2__btn--link').on('click', function() {
    var headerHight = $('header').height();
    var speed = 1000;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - headerHight;

    $('html,body').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});


